// Privātie sludinājumi (C2C) — lightweight localStorage cart. A classifieds
// cart holds items from a SINGLE seller (one escrow order = one seller).
// Kept separate from the shop `cart_items` server cart.
const KEY = 'kolv_cls_cart';
export const CLS_CART_EVENT = 'kolv-cls-cart-change';

export function getClsCart() {
  try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
}

function save(cart) {
  localStorage.setItem(KEY, JSON.stringify(cart));
  if (typeof window !== 'undefined') window.dispatchEvent(new Event(CLS_CART_EVENT));
}

export function clsCartCount() { return getClsCart().length; }
export function isInClsCart(id) { return getClsCart().some((i) => i.id === id); }

// item: {id, sellerId, sellerName, title, price, image, slug}
// returns {ok, already?, reason?}
export function addToClsCart(item) {
  const cart = getClsCart();
  if (cart.some((i) => i.id === item.id)) return { ok: true, already: true };
  if (cart.length && cart[0].sellerId !== item.sellerId) return { ok: false, reason: 'different_seller' };
  cart.push(item);
  save(cart);
  return { ok: true };
}

export function replaceClsCart(item) { save([item]); }
export function removeFromClsCart(id) { save(getClsCart().filter((i) => i.id !== id)); }
export function clearClsCart() { save([]); }
